import React, { useState, useEffect } from "react";
import { HashRouter, Route, Switch, Redirect, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setJwtClaimAsync,
  setJwtClaimEmptyAsync,
  setApiAuthToken,
  setRefreshTimerAsync,
  setJwtClaimRefreshAsync,
  selectJwtClaim,
} from "views/LoginForm/loginSlice";
import { setAppType, selectAppType } from "common/appSlice";
import { http } from "common";
import { axiosApi } from "common/httpService";
import LoginForm from "views/LoginForm";
import { DefaultLayout, DefaultView, NotFound, CurtainReveal } from "containers";
import { ArtistGroupAssocInvite } from "views/test";
// import { CTableTest } from "views/test";
import ArtistGroupAssocAcceptInvite from "views/artist/artistGroup/ArtistGroupAssocAcceptInvite";
import ArtistEventReqAssocAcceptInvite from "views/artist/artistEventReq/ArtistEventReqAssocAcceptInvite";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import "./common/table-custom.css";

import { artisGroupAcceptInviteUrlPath } from "properties/config.json";
import { artisEventReqAcceptInviteUrlPath } from "properties/config.json";

const DebugRouter = ({ children }: React.PropsWithChildren<unknown>) => {
  const { location } = useHistory()
  if (process.env.NODE_ENV === "development") {
    console.log(
      `Route: ${location.pathname}${location.search}, State: ${JSON.stringify(
        location.state,
      )}`,
    )
  }

  return children
}


/*eslint-disable no-eval */
function App() {
  let jwtClaim = useSelector(selectJwtClaim);
  const localStoragedata = localStorage.getItem("CHAKRA_IC");
  // eslint-disable-next-line
  let [inputs, setInputs] = useState({
    username: "",
    password: "",
  });
  // eslint-disable-next-line
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const appType = useSelector(selectAppType);

  useEffect(() => {
    if (jwtClaim !== null) {
      let { username, refreshtoken, token, tokenDetail } = jwtClaim; 
      http.setAuthToken(token);
      dispatch(setApiAuthToken(jwtClaim));
      dispatch(setRefreshTimerAsync(jwtClaim));
    } else if (localStoragedata !== null) {
      const data = eval("(" + localStoragedata + ")");
      http.setAuthToken(data.token);
      dispatch(setJwtClaimRefreshAsync(data.username, data.refreshtoken));
      dispatch(setRefreshTimerAsync(data));
    }
  }, [jwtClaim, localStoragedata, dispatch]);

  useEffect(() => {
    fetch('/getServerMetaData')
      .then(res => res.json())
      .then(data => {console.log(data); dispatch(setAppType({appType: data.appType}));})
      .catch((error) => { console.log(error); });
  }, []);

  function onLogin(data, props) {
    setInputs({ ...data });
    setSubmitted(true);
    dispatch(setJwtClaimAsync({...data, appType: appType}, props));
  }
  function onLogout(e, props) {
    dispatch(setJwtClaimEmptyAsync(inputs, props));
  }
  return (
    <HashRouter>
      <ToastContainer />
      <React.Suspense>
       <DebugRouter>
        <Switch>
          <Route path="/not-found" component={NotFound} />
          <Route path="/curtain-reveal" component={CurtainReveal} />
          {/* Test Code
          <Route path="/test/artist/artistGroup/invite" component={ArtistGroupAssocInvite} />
	  */}
          <Route path={artisGroupAcceptInviteUrlPath} component={ArtistGroupAssocAcceptInvite} />
          <Route path={artisEventReqAcceptInviteUrlPath} component={ArtistEventReqAssocAcceptInvite} />
          {/* <Route path="/test" component={CTableTest} /> */}
	  <Route path="/aimslogin" render={(props) => { window.location.href = '/redirectaims'; }} />
	  <Route path="/artistlogin" render={(props) => { window.location.href = '/redirectams'; }} />
          <Route
            path="/login"
            render={(props) => {
              if (jwtClaim === null || Object.keys(jwtClaim).length === 0) {
                return <LoginForm {...props} fromLocation="/login" handleLogin={onLogin} />;
              } else {
                return (
                  <DefaultLayout
                    {...props}
                    items={jwtClaim}
                    handlelogout={onLogout}
                  />
                  // <DefaultView
                  //   {...props}
                  //   items={jwtClaim}
                  //   handlelogout={onLogout}
                  // />
                );
              }
            }}
          />
          <Route
            path="/"
            render={(props) => {
              if (jwtClaim === null || Object.keys(jwtClaim).length === 0) {
	        const currLoginLocationPathname = localStorage.getItem("iccrLoginLocationPathname");
		if (currLoginLocationPathname !== undefined) {
		  return (<Redirect to={currLoginLocationPathname} />);
		} else {
                  return <LoginForm {...props} fromLocation="/login" handleLogin={onLogin} />;
		}
              } else {
                return (
                  <DefaultLayout
                    {...props} aims="off"
                    items={jwtClaim}
                    handlelogout={onLogout}
                  />
                  // <DefaultView
                  //   {...props}
                  //   items={jwtClaim}
                  //   handlelogout={onLogout}
                  // />
                );
              }
            }}
          />
          <Redirect to="/not-found" />
        </Switch>
       </DebugRouter>
      </React.Suspense>
    </HashRouter>
  );
}

export default App;
